module.exports = __webpack_public_path__ + "static/weekview-53e8e14b340ded777d21bc13e15c9a7d.png";